module.exports = __webpack_public_path__ + "img/product_40.7cd52cc.webp";